import * as React from 'react';
import { Popconfirm } from 'antd';
import { ConfirmButtonProps } from '../admin-banners.type';
import Button from '/react4xp/mixins/ui/button/button';

export const ConfirmButton = ({ children, ...props }: ConfirmButtonProps) => {
    return (
        <Popconfirm {...props}>
            <Button>{children}</Button>
        </Popconfirm>
    );
};
